<div layout="row" layout="column"       layout-align="center center">
    <md-card flex-gt-md="60" flex="100">
      <div class="md-whiteframe-1dp" flex>
          <md-card-header layout-padding style="background-color:#7F8FB1;color: white">
                <md-card-header-text>
            <span class="md-body-1" >{{vm.campionat}}</span>
          </md-card-header-text>
                <md-card-header-text style="text-align:right">
            <span class="md-headline">{{vm.suspes}}</span>
          </md-card-header-text>
              </md-card-header>
          
        <md-card-header layout-padding style="background-color:#D2E0E6;color: black">
        
              <md-card-header-text>
            <span class="md-body-1">Data</span>
          </md-card-header-text>
             <md-card-header-text>
            <span class="md-body-1">Equip local</span>
          </md-card-header-text>
             <md-card-header-text>
            <span class="md-body-1">Equip visitant</span>
          </md-card-header-text>
             <md-card-header-text>
            <span class="md-body-1">C.C.</span>
          </md-card-header-text>
           
        </md-card-header>
          
     
         
        <md-card-header layout-padding>
        
              <md-card-header-text>
            <span class="md-body-1">{{vm.data}}</span>
          </md-card-header-text>
             <md-card-header-text>
            <span class="md-body-1">{{vm.elocal}}</span>
          </md-card-header-text>
             <md-card-header-text>
            <span class="md-body-1">{{vm.evisitant}}</span>
          </md-card-header-text>
             <md-card-header-text>
            <md-checkbox ng-model="vm.cc" aria-label="Checkbox 1">
            
          </md-checkbox>
          </md-card-header-text>
            
        </md-card-header>
            <md-card-header layout-padding>
                 <md-card-header-text>
            <span class="md-body-1">{{perfilnom}}</span>
          </md-card-header-text>
                <md-card-header-text>
            <span class="md-body-1">{{equipnom}}</span>
          </md-card-header-text>
                      <md-card-header-text>
            <span class="md-body-1"></span>
          </md-card-header-text>
            </md-card-header>
          <md-card-content>
  <md-table-container>
      <table md-table md-row-select="true" >
          <tr md-row md-select="vm.select">
                <td md-cell>{{item4.iditem}}</td>
               <td md-cell>{{item4.nom}}</td>
              <td md-cell>{{item4.respetoa}}</td>
              <td md-cell><select placeholder="Valoració" ng-model="select4"  ng-init="select4 =vm.init4" style=";color: black"  >
                      <option  ng-repeat="opcion4 in opcions4"  >{{opcion4.name}}<option>
                  </select></td>
          </tr>
            <tr md-row md-select="vm.select">
                <td md-cell>{{item5.iditem}}</td>
               <td md-cell>{{item5.nom}}</td>
              <td md-cell>{{item5.respetoa}}</td>
              <td md-cell><select placeholder="Valoració" ng-model="select5"  ng-init="select5 =vm.init5" style=";color: black"  >
                      <option  ng-repeat="opcion5 in opcions5" >{{opcion5.name}}<option>
                  </select></td>
          </tr>
          
          
           <tr md-row md-select="vm.select">
                <td md-cell>{{item6.iditem}}</td>
               <td md-cell>{{item6.nom}}</td>
              <td md-cell>{{item6.respetoa}}</td>
              <td md-cell><select placeholder="Valoració" ng-model="select6" ng-init="select6 =vm.init6" style=";color: black"  >
                      <option  ng-repeat="opcion6 in opcions6" >{{opcion6.name}}<option>
                  </select></td>
          </tr>
          
           <tr md-row md-select="vm.select">
                <td md-cell>{{item7.iditem}}</td>
               <td md-cell>{{item7.nom}}</td>
              <td md-cell>{{item7.respetoa}}</td>
              <td md-cell><select placeholder="Valoració" ng-model="select7" ng-init="select7 =vm.init7" style=";color: black"  >
                      <option  ng-repeat="opcion7 in opcions7" >{{opcion7.name}}<option>
                  </select></td>
          </tr>
          
      </table>
  </md-table-container>
       
          </md-card-content>
          
      </div>
    </md-card>
    </div>
<md-button type="submit" class="md-fab md-accent md-fab-bottom-right"  ng-click="vm.click()"
             ng-disabled="editForm.$invalid">
    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>
  </md-button>